<template>
  <div>
    <vuejs-datepicker v-show="!disableDatePicker" :highlighted="highlightedDates" :disabledDates="prevDatesOnly ? { from: new Date() } : {}"  @selected="datePickerSelect" format="dd / MM / yyyy" :value="defaultDate" :clear-button="true"></vuejs-datepicker>

    <div v-show="disableDatePicker" v-if="disableDatePicker" class="cover" @keyup.capture="updateValue">
      <input type="number" class="date-input" placeholder="DD" :value="day" @input="dayInput" ref="day">
      <span>/</span>
      <input type="number" class="date-input" placeholder="MM" :value="month" @input="monthInput" ref="month" @keyup="onMonthKeyup">
      <span>/</span>
      <input class="date-input year" type="number" placeholder="YYYY" :value="year" @input="yearInput" ref="year" @keyup="onYearKeyup">
    </div>
  </div>
</template>


<script>

import vuejsDatepicker from 'vuejs-datepicker';
import moment from 'moment';
import { mapGetters } from 'vuex';

import OrderDrugService from '@/core/api/order/orderDrug.service';

export default {
  name: 'FormDate',
  props: {
    showDateAlerts: Boolean,
    value: {
      default: '',
    },
    disableDatePicker: {
      type: Boolean,
      default: false,
    },
    prevDatesOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vuejsDatepicker,
  },
  data() {
    return {
      day: '',
      month: '',
      year: '',
      defaultDate: null,
      public_holidays: null,
    };
  },
  computed: {
    ...mapGetters(['authenticatedUser']),
    highlightedDates() {
      if (this.showDateAlerts) {
        const holidays = { dates: [], classes: 'publicHoliday' };
        if (this.public_holidays) {
          this.public_holidays.forEach((holiday) => {
            const dateString = holiday.date;
            const year = parseInt(dateString.substring(0, 4), 10);
            const month = parseInt(dateString.substring(4, 6), 10) - 1; // Subtract 1 because JavaScript months are 0-indexed
            const day = parseInt(dateString.substring(6, 8), 10);
            const date = new Date(year, month, day);
            holidays.dates.push(new Date(date));
          });
        }
        return holidays;
      }
      return {}
    }
  },
  watch: {
    value(val) {
      if ((val === '') || (!val)) {
        this.day = '';
        this.month = '';
        this.year = '';
      } else {
        const t = val.split('/');
        const day = t[0];
        const month = t[1];
        const year = t[2];

        this.day = day;
        this.month = month;
        this.year = year;
      }
    },
    day(current, prev) {
      if (current > 31) this.day = prev;
    },
    month(current, prev) {
      if (current > 12) this.month = prev;
    },
    year(current, prev) {
      if (current > 9999) this.year = prev;
    },
  },
  created() {
    const reqData = {
      state: this.authenticatedUser.hospitalStateCode
    }

    OrderDrugService.publicHolidays(reqData).then((resp) => {
        const { data } = resp;
        this.public_holidays = data
    });
  },
  mounted() {
    this.setDefaultDate();
  },
  methods: {
    setDefaultDate() {
      if (this.value !== '' && this.value) {
        const t = this.value.split('/');
        const day = t[0];
        const month = t[1] - 1;
        const year = t[2];

        this.day = day;
        this.month = month + 1;
        this.year = year;

        this.defaultDate = this.month + '/' + this.day + '/' + this.year; // 8/4/2024';// new Date(year, month, day);
      }
    },
    isWeekend(date) {
      return moment(date).day() === 0 || moment(date).day() === 6;
    },
    datePickerSelect(dateObj) {
      this.date_warning = ''
      this.$emit('update-warning', ``);
      if (dateObj) {
        this.day = dateObj.getDate();
        this.month = dateObj.getMonth() + 1;
        this.year = dateObj.getFullYear();
        this.updateValue();

        if (this.showDateAlerts) {
          const date = moment(`${this.year}/${this.month}/${this.day}`).format('YYYYMMDD');
          const isWeekend = this.isWeekend(date)

          if (isWeekend) {
            this.$emit('update-warning', `Note: ${moment(date).format('DD/MM/YY')} is a weekend`);
            return
          }
          if (this.public_holidays) {
            this.public_holidays.forEach((publicHoliday) => {
                if (publicHoliday.date === date) {
                  this.$emit('update-warning', `Note: ${moment(date).format('DD/MM/YY')} is a public holiday`);
                }
            });
          }
        }
      } else {
        this.day = '';
        this.month = '';
        this.year = '';
      }
    },
    dayInput(e) {
      this.day = e.target.value;

      if (e.target.value.length >= 2) {
        this.$refs.month.focus();
      }
    },
    monthInput(e) {
      this.month = e.target.value;

      if (e.target.value.length >= 2) {
        this.$refs.year.focus();
      }
    },
    yearInput(e) {
      this.year = e.target.value;
    },
    onMonthKeyup(e) {
      if (e.target.value === '') {
        if (e.keyCode === 8) {
          this.$refs.day.focus();
        }
      }
    },
    onYearKeyup(e) {
      if (e.target.value === '') {
        if (e.keyCode === 8) {
          this.$refs.month.focus();
        }
      }
    },
    updateValue() {
      if (this.day === '' && this.month === '' && this.year === '') {
        this.$emit('input', '');
        return;
      }

      const date = `${this.day}/${this.month}/${this.year}`;
      this.$emit('input', date);
    },
  },
};
</script>

<style lang="scss">
.vdp-datepicker__clear-button{
  position: absolute;
  top: 5px;
  right: 0;
  span{
    i{
      span{
        font-style: normal;
        font-size: 25px;
        display: block;
        padding: 10px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.bax-form-error, .bax-error {
  .cover {
    border: 1px solid red;
  }
}
.cover {
  // padding: 16px 14px;
  background-color: white;
  border: 1px solid #CCC;
  padding-left: 10px;

  .date-input {
    width: 40px;
    padding: 0;
    height: 54px;
    border: none;
    background-color: transparent;
    text-align: center;
    outline: none;
    font-size: 16px;

    &:focus {
      outline:none !important;
      box-shadow: none;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
    }
  }

  .year {
    width: 53px;
  }
  span {
    display: inline-block;
    width: 10px;
    text-align: center;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}
</style>
